import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { fetchOrder,applyOrder } from '../../actions/order'
import Button from '../../components/uiKit/Button'
import Icon from '../../components/misc/Icons'
import {showNotification} from '../../actions/notifications'
import { Field, reduxForm} from 'redux-form'
import FormFieldText from '../../components/uiKit/FormFieldText'


class AddLicenseKeyForm extends React.Component{

	render(){


		return(			
				<form onSubmit={this.props.handleSubmit} autoComplete='off'>				
				    <Field 
		        		name='licenseKey'
		        		label={false}
		        		size='large'		        		
				        component={FormFieldText}
				        placeholder='License Key'				        
				        autoFocus={true}
				        autoComplete='false'				        
				    />    	

    				<div className='addLicenseKeyModal-actionRow'>	
	        		<Button 
	        			size='xLarge'
	        			color={this.props.dirty && this.props.valid ? 'blue' : 'gray'}
	        			submitLoading={this.props.submitLoading}
	        			label='Add License Key'
	        			canSubmit={this.props.dirty && this.props.valid && !this.props.submitLoading ? true : false}
	        			//disabled={!canSubmit}
	        			type='submit'
	        			name='submitLicense'
	        		/>
	        		<Button 
	        			size='xLarge'
	        			color='white'        			
	        			label='Cancel' 
	        			onClickFunction={this.props.hideModal}              			
	        		/>
	        </div>
	     		 </form>		
		)
	}
}


AddLicenseKeyForm = reduxForm({
	form: 'AadLicenseKeyForm',
	enableReinitialize: true,
	autoComplete:'off'
})(AddLicenseKeyForm)





class AddLicenseKeyContainer extends Component {

 
	constructor(props){
		super(props)
		this.applyLicenseKey=this.applyLicenseKey.bind(this)


		this.state = {
      		submitLoading:false,
      		failedToFetchOrder:false,
      		failedToApplyOrder:false
    	}
	}



	UNSAFE_componentWillMount() {
		document.body.style.overflowY='hidden'
	}

	componentDidMount(){
		if(window.analytics){
			window.analytics.page('Add License Key Modal')
		}
	}

 
	componentWillUnmount() {
		document.body.style.overflowY='' // overlay is not supported by firefox, so default to blank (auto style comes from css)
		document.body.style.overflowY='overlay' // overlay is to prevent windows scrollbars interacting with pagewidth
	}






	applyLicenseKey(formData){
		this.setState({submitLoading:true})
		//fetch order

		 if(window.analytics){
					window.analytics.track('Click claim membership', {
				  		method:'Add license key',

				})}

		this.props.fetchOrder(formData.licenseKey).then((response)=>{
			const orderId=response.id 
			this.props.applyOrder(orderId,formData.licenseKey).then(()=>{
				this.props.hideModal()
				this.props.showNotification('Plickers Pro has been activated on your account','Successfully joined order –','default')
				 if(window.analytics){
					window.analytics.track('Successfully Claimed Membership', {
				  		method:'Add license key',

				})}


			})
			.catch((error) => {
				if(window.analytics){
					window.analytics.track('Error claim membership', {
				  		method:'Add license key',
				  		error:'Failed to apply order'
				})}


		 		this.setState({submitLoading:false,failedToApplyOrder:true})
			 })
		})

		.catch((error) => {
			if(window.analytics){
					window.analytics.track('Error claim membership', {
				  		method:'Add license key',
				  		error:'Failed to fetch order'
				})}

		 	this.setState({failedToFetchOrder:true,submitLoading:false})
		 })
	}






	
	render() {
		
		const {failedToFetchOrder,failedToApplyOrder,submitLoading} = this.state

		
		

		return (

		<div className='addLicenseKeyModal'>

			<div className='addLicenseKeyModal-header'>
				Add License Key
			</div>
			
			<div className='addLicenseKeyModal-sub'>
				Enter the 10-digit license key provided by your administrator.
			</div>
			
		
			<AddLicenseKeyForm
				onSubmit={this.applyLicenseKey}
				hideModal={this.props.hideModal}
				submitLoading={submitLoading}
			/>

			<a className='addLicenseKeyModal-link' target='_blank' rel='noopener noreferrer' href='https://goo.gl/forms/rzO20JZf1eu8aauI2'>
				If you are looking to upgrade your department, school, or district, contact us to find about our bulk discounts.
			</a>


			<div className={'addLicenseKeyModal-errorSpace ' + ((failedToFetchOrder || failedToApplyOrder) ? 'addLicenseKeyModal-errorSpace--hasError' : '')} >
				{failedToFetchOrder &&
					<span>
						License key is invalid. Check and try again. If you're still having trouble contact help@plickers.com or your system adminstrator
					</span>
				}
				{failedToApplyOrder &&
					<span>
						Error Processing Order: please contact help@plickers.com or your system adminstrator
					</span>
				}
			</div>


				{/* 



					{failedToFetchOrder &&
						<React.Fragment>
							<div className='applyOrderModal-closeBtn' onClick={this.props.closeModal}>
								<Icon name='circle-with-close' />
							</div>
							<div className='applyOrderModal--error-h1'>
								Order Details not found
							</div>
							<div className='applyOrderModal--error-h2'>
								Please contact <b>help@plickers.com</b> or your system administrator.
							</div>

							<Button 
								label='Done'
								name='errordone'
								color='blue'
								size='xLarge' 
								onClickFunction={this.props.closeModal}								
							/>

						</React.Fragment>
					}

				
				{!failedToFetchOrder &&
					<React.Fragment>
						
						<div className='applyOrderModal-closeBtn' onClick={this.props.hideModal}>
							<Icon name='circle-with-close' />
						</div>

						<div className='applyOrderModal-h1'>
							Take advantage of free Plickers Pro,<br/>
						</div>
						<div className='applyOrderModal-benefitsHeader'>
							What's included with Plickers Pro
						</div>

						<div className='applyOrderModal-benefitsContainer'>
							<div className='applyOrderModal-benefit'>							
								<div className='applyOrderModal-benefit-header'>							
									Unlimited Set Editor
								</div>
								<div className='applyOrderModal-benefit-desc'>							
									Create sets without question limits, and use Instant Images to easily add visuals to your questions.
								</div>
							</div>
							<div className='applyOrderModal-benefit'>							
								<div className='applyOrderModal-benefit-header'>							
									Shared Packs
								</div>
								<div className='applyOrderModal-benefit-desc'>							
									Share sets with your colleagues and build curriculum content together. Invite people as co-editors or viewers.
								</div>
							</div>
							<div className='applyOrderModal-benefit'>							
								<div className='applyOrderModal-benefit-header'>							
									Unlimited Scoresheet
								</div>
								<div className='applyOrderModal-benefit-desc'>							
									Use 90-day and custom date-ranges and get the long-view on class and student performance.
								</div>
							</div>
							<div className='applyOrderModal-benefitsCloudBG'>							
								<svg width="765" height="157" viewBox="0 0 765 157">
							  	<path d="M15.1380325,20.2494031 C28.7199981,-1.46634244 235.612755,2.56514859 410.618837,2.56514859 C653.733319,2.56514859 728.149411,-12.6543541 754.264981,31.0503694 C763.731677,46.8929993 772.319604,122.018979 754.264981,144.036255 C736.210358,166.053532 514.062989,152.301287 440.595704,153.565149 C293.130881,156.101993 19.1388815,160.328607 6.32810893,144.036255 C-6.21722229,128.081484 1.55606698,41.9651486 15.1380325,20.2494031 Z"/>
								</svg>							
							</div>
						</div>

					

						{!failedToApplyOrder &&						
							<div className='applyOrderModal-smallPrint'>
								If you join the order, we’ll display your basic profile information to your order administrator.
							</div>
						}
						{failedToApplyOrder &&						
							<div className='applyOrderModal-smallPrint applyOrderModal-smallPrint--error'>
								Error Processing Order: please contact help@plickers.com or your system adminstrator
							</div>
						}



						<div onClick={this.props.hideModal} className='applyOrderModal-noThanks'>						
							No thanks, I don't want to join this order
						</div>
					</React.Fragment>
			
				}
				*/}

			</div>
		)
	}

}





export default withRouter(connect(
	(state) => ({
		order:state.order
	
	}),
	{ fetchOrder,applyOrder,showNotification}
)(AddLicenseKeyContainer))






// WEBPACK FOOTER //
// ./src/containers/account/AddLicenseKeyContainer.js